module.exports = __webpack_public_path__ + "static/media/loader.a9beea16.svg";